let env = process.env.REACT_APP_ENV;

console.log(`Current Env ${env}`);

const appConfig = {
  apiPrefix:
    env ?  "/v1/student/api" : "http://localhost:8080/api",
  authenticatedEntryPath: "/app/home",
  unAuthenticatedEntryPath: "/sign-in",
  publicRoute: "/",
  enableMock: true,
  appBackendUrl:
      env ?  "/v1/student/api" : "http://localhost:8080/api",
};

export default appConfig;
